import { useApplicationContext } from '../../../../../../provider'
import { resolveFullSnippetPath } from '../../../../codeblock-highlight/code-snippets/resolveFullSnipperPath'
import {
  getSelectedSources,
  getUnselectedSources,
  parseSelectedSources,
  parseUnselectedSources,
} from '../../helpers/fundingSourcesAssets'

export default (props: any) => {
  const { nonce } = useApplicationContext()
  const { paymentModel } = props
  const integrationType = props.options.find(
    (option: any) => option.name === 'integration',
  ).value

  const fundingSourceCodeMap: any = {
    PAYPAL: 'PAYPAL',
    PAYLATER: 'CREDIT',
    CARD: 'CARD',
  }

  let selectedSources = props.buttons.map((button: string) =>
    button.split('payment-buttons_')[1].toUpperCase(),
  )

  if (paymentModel === 'recurring') {
    selectedSources = selectedSources
      .map((source: string) => fundingSourceCodeMap[source])
      .filter(Boolean)
  }

  let snippetPath = resolveFullSnippetPath(
    `/jscript/integration-examples/standard-checkout.js`,
  )

  const buttons = getSelectedSources(props.buttons)

  const selectedButtons = parseSelectedSources(props, buttons)
  const unselectedButtons = parseUnselectedSources(
    props,
    getUnselectedSources(buttons),
  )

  const scriptString = `https://www.paypal.com/sdk/js?client-id=test&enable-funding=${
    selectedButtons.length > 0 ? selectedButtons : 'paypal'
  }${
    unselectedButtons.length > 0 ? `&disable-funding=${unselectedButtons}` : ''
  }`

  return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <title>PayPal Standard Payments Integration | Client Demo</title>
      </head>
      <style>
          #paypal-button-container {
              display: flex;
              flex-direction: ${
                props.buttonLayout === 'vertical' ? 'column' : 'row'
              };
          }
      
          .paypal-buttons {
              margin-top: 15px;
              margin-right: 15px;
          }
      </style>
  
      <body style="${
        props.buttonLayout === 'vertical' ? 'width:300px;' : ''
      }margin: auto;">
        <div id="paypal-button-container" ></div>
        <!-- Sample PayPal credentials (client-id) are included -->
        <style>
        .paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {
          opacity: 0 !important;
        }
        </style>
        <script src="${scriptString}"${
    nonce ? ` data-csp-nonce="${nonce}"` : ''
  }></script>
        <script id="standard-checkout" src="${snippetPath}?shape=${
    props.buttonStyle
  }&layout=${
    props.buttonLayout
  }&fundingSources=${selectedSources}&paymentModel=${paymentModel}&integrationType=${integrationType}"${
    nonce ? ` data-csp-nonce="${nonce}"` : ''
  }></script>
    </body>
    </html> `
}
